/** True when pathname is the prefix itself or a path below it (not a sibling such as /exports-old). */
export const isPathUnderPrefix = (pathname?: string, prefix?: string): boolean =>
  !!pathname && !!prefix && (pathname === prefix || pathname.startsWith(`${prefix}/`));
